import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import GET_SAVED_CARDS_QUERY from 'Jsx/CheckoutV4/Graphql/Query/SavedCardQuery.graphql';

const useSavedCards = ({ isLogged }: { isLogged: boolean }) => {
  const [savedCards, setSavedCards] = React.useState([]);
  const { data, loading, error } = useQuery(GET_SAVED_CARDS_QUERY, {
    skip: !isLogged,
  });

  React.useEffect(() => {
    if (
      !loading &&
      !error &&
      data?.customerCards &&
      data?.customerCards.length > 0
    ) {
      setSavedCards(data.customerCards.filter(card => !card.isExpired));
    }
  }, [loading]);

  return { savedCards, loading, error };
};

export default useSavedCards;
